const APP_ENV = process.env.REACT_APP_ENV || 'development';
window.env = APP_ENV;
const productionApiUrl = 'https://api.upperclassdates.com/api';
const devApiUrl = 'https://api.staging.upperclassdates.com/api';
const authProductionApiUrl = 'https://api.upperclassdates.com';
const authDevApiUrl = 'https://api.staging.upperclassdates.com';

const stripeConfig = {
  development: {
    apiKey: 'pk_test_fUm5kT3RcWzvuh3ghJ4IOao5',
    returnUrl: 'https://api.staging.upperclassdates.com/api/end-payment'
  },
  production: {
    apiKey: 'pk_live_BNPqLXusxtIXRjvftA842M95',
    returnUrl: 'https://api.upperclassdates.com/api/end-payment',
  }
};

const paypalConfig = {
  sandbox: 'ATDxN1_Qhwu3huV8noshxRsWOWv1I-GBs-5-GevQJp6xK4nbiVvYQMJ1xw6evakAgKZJjXI4LEfWJiKa',
  production: 'AahcOr5M4vKgd4Rd2Lwtz-LiWyQn-cKApWHo3NX8xC15YKqmU5ZWNlIEpvB7f27zBdJLyEHx7gH2kghF'
};

const oauthPasswdConfig = {
  staging:{
    "grant_type": "password",
    "client_id": "2",
    "client_secret": "9OwB1gAQcULEeuQe3FI5wX6dwzemsvwHMl2KKcM0",
    "scope": ""
  },
  development: {
    "grant_type": "password",
    "client_id": "1",
    "client_secret": "fY7OaBQA3sbtZi97SzbgBZaQx6qNceYJn846vJdZ",
    "scope": ""
  },
  production: {
    "grant_type": "password",
    "client_id": "1",
    "client_secret": "1gxIwqH7zBwsBZBLW2AlaHN9A0yMjQxbmYam7seD",
    "scope": ""
  },
};
const prodIntercomKey = 'kl6j5jkg';
const stagingIntercomKey = 'kl6j5jkg';

const config = {
  apiUrl: (APP_ENV === 'production' ? productionApiUrl : devApiUrl),
  intercomKey: (APP_ENV === 'production' ? prodIntercomKey : stagingIntercomKey),
  useAnalytics: (APP_ENV === 'production' ? true : false),
  analyticsCode: 'UA-111442323-1',
  authUrl: (APP_ENV === 'production' ? authProductionApiUrl : authDevApiUrl),
  oauthConfig: oauthPasswdConfig[APP_ENV],
  stripeConfig: stripeConfig[APP_ENV],
  paypalConfig,
  paypalEnv: (APP_ENV === 'production' ? 'production' : 'sandbox')
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/config.js